import app from "./app";

import 'bootstrap/dist/css/bootstrap.css';
import 'sweetalert/dist/sweetalert.css';
import './styles/angucomplete.css';
import 'angular-material/angular-material.css';
import 'mdPickers/dist/mdPickers.css';
import 'angular-material-data-table/dist/md-data-table.css';
import 'ng-sortable/dist/ng-sortable.css';
import 'md-date-range-picker/dist/md-date-range-picker.css';

import './styles/template.css';
import './styles/mobile-template.css';
import './styles/text.css';
import './styles/elements.css';
import './styles/welcome.css';
import './styles/ojd-detail.css';
import './styles/ojd-detail-mobile.css';
import './styles/ojd-detail-desktop.css';
import './styles/dashboard.css';
import './styles/allocations.css';
import './styles/admin.css';
import './styles/preAuthPage.css';

import './styles/custom-input.css';
import './styles/custom-list.css';
import './styles/custom-tablelist.css';
import './styles/custom-loader.css';
import './styles/custom-icons.css';
import './styles/custom-docketfiler.css';
import './styles/alerts.css';
import './styles/responsive-utilities.css';
import './styles/bootstrap-override.css';
import './styles/plans.css';
import './styles/docket-designer.css';

import googleplace from './lib/directive/googleplace';

import accessControl from "./factories/accessControl";
import formatHelper from "./factories/formatHelper";
import splitListInterface from "./factories/splitListInterface";

import addressBookService from "./services/addressBookService";
import alertService from "./services/alertService";
import batchService from "./services/batchService";
import docketService from "./services/docketService";
import jobService from "./services/jobService";
import orderService from "./services/orderService";
import resourceService from "./services/resourceService";
import userService from "./services/userService";
import xeroService from "./services/xeroService";
import billingService from "./services/billingService";

import loadingController from "./controllers/loading";
import scopeNavController from "./controllers/scopeNav";
import trailBannerController from "./controllers/trialBannerController";
import selectContactController from "./controllers/selectors/selectContactController";
import selectQuoteController from "./controllers/selectors/selectQuoteController";
import editContactController from "./controllers/modals/editContactController";
import newOrgModalController from "./controllers/modals/newOrgModalController";
import acceptOrderWizardModalController from "./controllers/modals/acceptOrderWizardModalController";
import recommendLineItemResourceModalController from "./controllers/modals/recommendLineItemResourceModalController";
import editUserModalController from "./controllers/modals/editUserModalController";
import editUserGroupRolesModalController from "./controllers/modals/editUserGroupRolesModalController";
import importContactsModalController from "./controllers/modals/importContactsModalController"
import importResourcesModalController from "./controllers/modals/importResourcesModalController"
import assignJobModalController from './controllers/modals/assignJobModalController'
import acceptConnectionRequestModalController from './controllers/modals/acceptConnectionRequestModalController'
import createConnectionModalController from './controllers/modals/createConnectionModalController'

import dashboardController from "./controllers/dashboard";
import navigationController from "./controllers/navigation";
import mainTemplateController from "./controllers/mainTemplateController";

import adminAccountController from "./controllers/admin.js";
import groupSettingsGeneralController from "./controllers/groupSettings/general";
import xeroConnectController from "./controllers/modals/xeroConnectController";
import selectRoleController from "./controllers/selectors/selectRoleController";
import selectPersonController from "./controllers/selectors/selectPersonController";
import groupSettingsAdminsController from "./controllers/groupSettings/admins";
import groupSettingsFilingController from "./controllers/groupSettings/filing"

import companySettingsBillingController from "./controllers/companySettings/billing";
import companySettingsUsersController from "./controllers/companySettings/users";
import companySettingsGroupsController from "./controllers/companySettings/groups";
import companySettingsRolesController from "./controllers/companySettings/roles";
import companySettingsTemplatesController from "./controllers/companySettings/templates";
import docketDesigner from "./controllers/docketDesigner/designer";
import companySettingsFieldsController from "./controllers/companySettings/fields"
import companySettingsChecklistsController from "./controllers/companySettings/checklists"
import companySettingsResourcesController from "./controllers/companySettings/resources"
import companySettingsCategoriesController from "./controllers/companySettings/resourceCategories"
import companySettingsUomsController from "./controllers/companySettings/uoms"

import ordersDesktopController from "./controllers/orders/desktopController"
import ordersDetailController from "./controllers/orders/detailController"
import ordersListController from "./controllers/orders/listController"
import ordersMobileDetailController from "./controllers/orders/mobileDetailController"

import selectResourceController from "./controllers/selectors/selectResourceController"
import selectTemplateController from "./controllers/selectors/selectTemplateController"

import jobsDesktopController from "./controllers/jobs/desktopController"
import jobsDetailController from "./controllers/jobs/detailController"
import jobsListController from "./controllers/jobs/listController"
import jobsMobileDetailController from "./controllers/jobs/mobileDetailController"

import selectLineController from "./controllers/selectors/selectLineController"
import selectOrderController from "./controllers/selectors/selectOrderController"

import docketDesktopController from "./controllers/dockets/desktopController";
import docketDetailController from "./controllers/dockets/detailController";
import docketListController from "./controllers/dockets/listController";
import docketMobileDetailController from "./controllers/dockets/mobileDetailController";

import filingDesktopController from "./controllers/filing/desktopController";
import filingListController from "./controllers/filing/listController";
import filingDetailController from "./controllers/filing/detailController";
import filingMobileDetailController from "./controllers/filing/mobileDetailController";

import batchListController from "./controllers/batches/batchListController";
import batchDetailController from "./controllers/batches/batchDetailController";

import selectJobController from "./controllers/selectors/selectJobController";
import selectXeroContactController from "./controllers/selectors/selectXeroContactController";
import interactionModalController from "./controllers/modals/interactionModalController";
import signatureModalController from "./controllers/modals/signatureModalController";
import checklistModalController from "./controllers/modals/checklistModalController";

import timesheetsController from "./controllers/timesheets/desktopController";

import contactsController from "./controllers/contacts";
import connectionsController from "./controllers/connections/connectionsController";

import mobileListController from "./controllers/mobileListController";
import lineItemModalController from "./controllers/modals/lineItemModalController";
import selectActivityController from "./controllers/selectors/selectActivityController";

import fieldModalController from "./controllers/modals/fieldModalController";
import newGroupModalController from "./controllers/modals/newGroupModalController";
import selectPlanController from "./controllers/modals/selectPlanController";

import preauthDocketController from "./controllers/preauth/preAuthDocketController";
import addressBookTagController from "./controllers/companySettings/addressBookTags";

import selectOrderLineController from "./controllers/selectors/selectOrderLineController";
import paywalledController from "./controllers/paywall/paywalledController"
import trialActivatedController from "./controllers/modals/trialActivatedModalController"



// WEBPACK FOOTER //
// ./src/index.js